import React from 'react';

import CollapsibleMenu from 'ui/properties-panel/collapsible-menu';
import InputField from 'ui/inline-text/input-field';

import styles from './emb-auto-dismiss.scss';

const rxUi = window.rxUi;

const NULL_DELAY = -1;
const DEFAULT_DELAY = 10;
const MAX_DELAY = 3600;
const MIN_DELAY = 0;

const validateDelay = (val, existingDelay) => {
  const parsed = parseInt(val, 10);
  const delay = parsed > MIN_DELAY ? val : existingDelay;

  return Math.max(Math.min(delay, MAX_DELAY), MIN_DELAY);
};

export default class EmbAutoDismiss extends React.Component {
  constructor() {
    super();

    // We want to avoid saving a user-entered value to the model while the feature is disabled,
    // but we still want to be able to restore that value if the user re-enables the feature.
    this._disabledDelay = DEFAULT_DELAY;

    this.state = {visible: false};

    this.handleEditorLayoutChange = this.handleEditorLayoutChange.bind(this);
    this.handleToggleEnabled = this.handleToggleEnabled.bind(this);
    this.handleSetDelay = this.handleSetDelay.bind(this);
  }

  componentDidMount() {
    this.props.editor.addListener('layoutChanged', this.handleEditorLayoutChange);

    this.uiBinding = new rxUi.Binding('EmbAutoDismiss');
    this.uiBinding
      .filterByEventType('setAutoDismiss')
      .ub_subscribe((ev) => {
        const {page} = this.props.editor;
        const rootElement = page.getRootElement();

        if (rootElement) {
          rootElement.model.set('displaySettings.autoDismissDelay', ev.delay, page.undoManager);
        }
      });
  }

  componentWillUnmount() {
    this.props.editor.removeListener('layoutChanged', this.handleEditorLayoutChange);
    this.uiBinding.dispose();
  }

  handleEditorLayoutChange() {
    const {page} = this.props.editor;
    const allowed = page.getConfigValue('allowAutoDismissEmbeddable');
    const rootElement = page.getRootElement();

    if (!allowed || !page.isFormConfirmation() || !rootElement) {
      this.setState({visible: false});
      return;
    }

    const delay = rootElement.model.safeGet('displaySettings.autoDismissDelay') || NULL_DELAY;
    const enabled = delay !== NULL_DELAY;

    this.setState({
      visible: true,
      enabled,
      delay,
    });
  }

  handleToggleEnabled(event) {
    const enabled = event.target.checked;
    const defaultedDelay = this.state.delay === NULL_DELAY ? this._disabledDelay : this.state.delay;
    const delay = enabled ? defaultedDelay : NULL_DELAY;

    this.uiBinding.onNext({type: 'setAutoDismiss', delay});
  }

  handleSetDelay(event) {
    const validated = validateDelay(event.target.value, this.state.delay);
    const delay = this.state.enabled ? validated : NULL_DELAY;

    this._disabledDelay = validated;
    this.uiBinding.onNext({type: 'setAutoDismiss', delay});
    this.setState({delay});
  }

  render() {
    const {visible, enabled, delay} = this.state;

    if (!visible) {
      return <noscript />;
    }

    return (
      <CollapsibleMenu title='Behavior'>
        <div className={styles.panelContent}>
          <label>
            <input
              type='checkbox'
              checked={enabled}
              className='form-elm-checkbox'
              onChange={this.handleToggleEnabled}
            />
            Close dialog after
            <InputField
              value={enabled ? delay : ''}
              readonly={!enabled}
              inputClassName='form-elm-input-text form-elm-mini-input'
              containerClassName={styles.inputField}
              valueChangeHandler={this.handleSetDelay}
              hideLabel
            />
            seconds
          </label>
        </div>
      </CollapsibleMenu>
    );
  }
}

EmbAutoDismiss.propTypes = {
  editor: React.PropTypes.shape({
    page: React.PropTypes.shape({
      isFormConfirmation: React.PropTypes.func.isRequired,
      settings: React.PropTypes.shape({contentType: React.PropTypes.string}),
    }),
    addListener: React.PropTypes.func.isRequired,
    removeListener: React.PropTypes.func.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/emb-auto-dismiss.jsx